import React from "react";
import { useSpinnerStyles } from "./SpinnerStyles";
const Spinner: React.FC<{ size?: number }> = ({ size }) => {
	const classes = useSpinnerStyles({ size: size ?? 80 });
	return <div className={`${classes.spinner} ${classes.spinnerOverride}`}></div>;
};

export default Spinner;
